import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Inject, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from '../service/token.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
// import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EffortInfo } from '../model/effort.model';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ReportEffortPlanProjectInfo } from '../model/reportEffortPlanProject.model';

export interface ResourcePlanningElement {
  no: number | null;
  EffortPlanProjectRole: string | null;
  EffortPlanEmpCode: string | null;
  ProjectSaleName: string | null;
  ProjectStart: Date | string | null;
  ProjectEnd: Date | string | null;
  EmployeeName: string | null;
  // EmpRoleDate: Date | null;
  ProjectSaleCode: string | null;
  ListEffort: EffortInfo ;
}


@Component({
  selector: 'app-resource-planning-report',
  templateUrl: './resource-planning-report.component.html',
  styleUrls: ['./resource-planning-report.component.css']
})
export class ResourcePlanningReportComponent implements OnInit {

  @Input() startDate: Date ;
  @Input() endDate: Date ;
  @Input() empCode: string ;
  @Input() empName: string ;
  @Input() projectName: string ;
  @Input() projectCode: string ;
  // @Input() triggerSearch: Boolean;

  displayedColumns: string[] = ['EffortPlanProjectRole', 'EffortPlanEmpCode', 'ProjectSaleName', 'Projects'];
  columnLabels: {[key: string]: string} ;
  columnsToDisplay: string[] = this.displayedColumns.slice();
  // dataSource: PeriodicElement[] = ELEMENT_DATA;
  // dataSource = new MatTableDataSource<ResourcePlanningElement>();
  dataSource: any = new MatTableDataSource<any>();
  // dataSource: any;
  i: number = 0;
  detailmodal: string;
  title: string;

  baseurl: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // @ViewChild('resourcePlaningDialog') resourcePlaningDialog!: TemplateRef<any>;

  mapPlaning = new Map<string, ResourcePlanningElement[]>();
  resourcePlanningData: ResourcePlanningElement[];
  mapKey: string[] = new Array<string>();
  resourcePlanningList: any;
  resourcePlanningListExport: any;

  effortPlanEmpCodeList: string[] = new Array<string>();
  timeSheetUserHours: number = 0;

  
  constructor(private httpClient: HttpClient, private TokenService: TokenService,
  public dialog: MatDialog) { 
    this.baseurl = environment.base_api;
  }

  ngOnInit(): void {

    this.resourcePlanningData = [];
    this.getResourcePlaning();
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    
    // console.log('Template ready:', this.resourcePlaningDialog);
  }

  ngOnChanges(changes: SimpleChanges) {
  //  console.log("startDateParent ", changes ,this.startDate);
  //  if (changes['triggerSearch'] && changes['triggerSearch'].currentValue === true) {
  //     console.log("changes['triggerSearch'] ===", changes['triggerSearch']);
      this.getResourcePlaning();
  //     this.triggerSearch = false;
  //   }
    
  //  this.getResourcePlaning();

  }

  // addColumn() {
  //   this.i += 1;
  //   const randomColumn = Math.floor(Math.random() * this.displayedColumns.length);
  //   // let randomColumn = 4;
  //   this.columnsToDisplay.push(this.displayedColumns[this.i]);
  // }

  viewResourcePlanningMonth(projectSaleName :string, projectStart: Date,
     projectEnd: Date, eff: EffortInfo, daysInMonth: number, projectCode: string, effortPlanEmpCode: string){
    console.log("viewResourcePlanningMonth..", projectSaleName, eff);
    console.log("projectCode == ", projectCode, effortPlanEmpCode);

    this.timeSheetUserHours = 0;
    if(projectCode != null && projectCode != ''){
        let effMonthYear = formatDate(eff.EffortMonthYear, "yyyy-MM", 'en-US');
        console.log("effMonthYear === ", effMonthYear);
        this.loadResourcePlanningActualEffort(projectSaleName, projectStart, projectEnd, eff,
           daysInMonth, projectCode, effortPlanEmpCode, effMonthYear);
     


     console.log("this.timeSheetUserHours ===", this.timeSheetUserHours)
    }
    
    // let strDetail: string = '';

    // for (let day of dataDays) {
    //     if(day != null){
    //       let d = formatDate(day, "dd-MM-yyyy", 'en-US');
    //       strDetail += 'Day: ' + d + ' <br>';
    //     } 
    //   }
    

  }

  async getResourcePlaning(){
    console.log("getResourcePlaning()..", this.projectName, this.empName);
      this.i += 1;

      var auth_token = await this.TokenService.RefreshToken(); 

      let params = new HttpParams();

      if(this.endDate){
        // this.endDate.setHours(23);
        // this.endDate.setMinutes(59);
        // this.endDate.setSeconds(59);
        // console.log("this.endDate === ", this.endDate);
        let enddate = formatDate(this.endDate, "yyyy-MM-dd", 'en-US');
        console.log("this.endDate === ", enddate);
         params = params.set('endDate', enddate);
    }
 
    if(this.projectName) params = params.set('projectName', this.projectName);
    if(this.empCode) params = params.set('empCode', this.empCode);
    if(this.empName) params = params.set('empName', this.empName);
    if(this.projectCode) params = params.set('projectCode', this.projectCode);

    
    let startdate = formatDate(this.startDate, "yyyy-MM-dd", 'en-US');
     params = params.set('startDate', startdate);

     params = params.set('pageSize', '100');
     params = params.set('pageNumber', '1');

    // console.log("tk = ", auth_token);

    let headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
              })
    let url = this.baseurl + "ProjectEffortPlan/GetResourcePlaning";          

      this.httpClient.get(url, { headers, params  })
      .toPromise()
      .then(res => this.getResourcePlaningRes(res))
      .catch(
        err => console.error("Error:", err));

  }

  getResourcePlaningRes(res){
    console.log("getResourcePlaningRes...", res.length)
    // console.log("getResourcePlaningRes2...", res.filter(x => x.EffortPlanEmpCode ==	"DP0133"));
    // this.mapKey = new Array<string>();

    if(res.length == 0){
      this.resourcePlanningList = [];
      let today = new Date();
      let monthsAgo = new Date(today.setMonth(today.getMonth() - 3));
      today = new Date();
      let nextMonths = new Date(today.setMonth(today.getMonth() + 3));
      this.startDate = new Date(monthsAgo.toISOString().substring(0, 10));
      this.endDate = new Date(nextMonths.toISOString().substring(0, 10));

      // Retry
      let limit = 5;
      while(this.i <= limit){
        this.getResourcePlaning()
      }




    }else{
      this.effortPlanEmpCodeList = new Array<string>();
      this.setResourcePlanningData(res);
    }
  }

  setResourcePlanningData(res){
   if(res){
      this.resourcePlanningData = res as ResourcePlanningElement[];
      let mapKey: string[] = new Array<string>();
      
      this.mapPlaning = this.resourcePlanningData.reduce((map, item) => {

        if (!map.has(item.EffortPlanEmpCode) && item.EffortPlanEmpCode != null) {
          map.set(item.EffortPlanEmpCode, []);
        }
        if (!mapKey.includes(item.EffortPlanEmpCode) && item.EffortPlanEmpCode != null) {
          mapKey.push(item.EffortPlanEmpCode);
        }
        this.mapKey = mapKey;

        map.get(item.EffortPlanEmpCode)?.push(item);

        return map;
      }, new Map<string, ResourcePlanningElement[]>());

    //     let key = this.mapPlaning.keys();

    // console.log("test map = ",  this.mapPlaning.get("DP0144")[0]);

    let data = Array.from(this.mapPlaning.entries()).map(([EffortPlanEmpCode, vals]) => {
      const groupedByProject = vals.reduce((acc: Record<string, any[]>, cur) => {
        if (!acc[cur.ProjectSaleName]) acc[cur.ProjectSaleName] = [];
        acc[cur.ProjectSaleName].push(cur);
        return acc;
      }, {});


      this.effortPlanEmpCodeList.push(EffortPlanEmpCode);
      return {
        EffortPlanEmpCode,
        EmployeeName: vals[0]?.EmployeeName,
        ProjectStart: vals[0]?.ProjectStart,
        ProjectEnd: vals[0]?.ProjectEnd,
        Projects: Object.entries(groupedByProject).map(([projectName, items]) => (
          {
            
            ProjectSaleName: projectName,
            // EffortPlanProjectRole: items[0],
            EffortPlanProjectRole: items.map(i => ({
                  EffortPlanId: i.EffortPlanId,
                  EffortGroupId: i.EffortGroupId,
                  EffortPlanProjectRole: i.EffortPlanProjectRole,
                  EffortPlanRole: i.EffortPlanRole,
              }
            )),
            ProjectSaleCode: vals.filter(x => x.ProjectSaleName === projectName)[0].ProjectSaleCode, // ProjectCode
            ListEffort: items[0]?.ListEffort?.map(effort => {
            const effortDate = new Date(effort.EffortMonthYear);

            let year = effortDate.getFullYear();
            let month =  effortDate.getMonth() + 1;
            const daysInMonth = new Date(year, month, 0).getDate();

            return {
              ...effort,
              DaysInMonth: daysInMonth 
            };
          }) || []

        }))

      };
    });

    console.log("this.effortPlanEmpCodeList === ", this.effortPlanEmpCodeList);

        this.resourcePlanningList = data;
        this.resourcePlanningListExport = data;


    //  this.dataSource.data

    console.log("data", this.resourcePlanningList);


    }
  }

  async loadResourcePlanningActualEffort(projectSaleName :string, projectStart: Date,
     projectEnd: Date, eff: EffortInfo, daysInMonth: number, projectCode: string, effortPlanEmpCode: string,  
     monthYear: string

  ){

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {


      let params = new HttpParams();

      if(effortPlanEmpCode) params = params.set('empCode', effortPlanEmpCode); else return;
      if(projectCode) params = params.set('projectCode', projectCode);  else return;
      if(monthYear) params = params.set('monthYear', monthYear);  else return;
      params = params.set('searchFormat', "1");

      console.log("param = ", params.toString());

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        }),
        params: params
      };


      let url = this.baseurl + "ProjectEffortPlan/GetResourcePlanningActual";  

      // return null;
      return await this.httpClient
            .get<ReportEffortPlanProjectInfo[]>(url, httpOptions)
            .toPromise().then(res => 
              {
                this.timeSheetUserHours = this.setReportEffortPlanProjectInfo(res)

                const dialogRef = this.dialog.open(ResourcePlanningReportModal, {
                      width: '800px',
                      data: {
                        projectSaleName: projectSaleName,
                        projectStart: projectStart,
                        projectEnd: projectEnd,
                        effortInfo: eff,
                        daysInMonth: daysInMonth,
                        timeSheetEmpHours: this.timeSheetUserHours
                      }
                    });

                    dialogRef.afterClosed().subscribe(result => {
                      console.log(`Dialog result: ${result}`);
                    });
              }).catch(err => {
                this.timeSheetUserHours = 0;
            });
    
    }

  }

  setReportEffortPlanProjectInfo(res: any){

    let reportEffs: ReportEffortPlanProjectInfo[] = res as ReportEffortPlanProjectInfo[];
    let timeSheetUserHours = 0;

      if(reportEffs.length > 0){
                  for(let i =0; i< reportEffs.length; i++){
                    // console.log("xxxx ", reportEffs[i].EmployeeCode, reportEffs[i].Hours);
                      timeSheetUserHours += reportEffs[i].Hours;
                  }
      }else{
        timeSheetUserHours = 0;
      }
            
      return timeSheetUserHours;
  }

  onExportResourcePlanningFile(){
    // console.log("xxxx", this.resourcePlanningListExport);
    // console.log("cccc", this.resourcePlanningData);
    if(this.resourcePlanningList){

      // let data = this.resourcePlanningListExport;

    let dataArr = [];  

      for(let i=0; i< this.resourcePlanningListExport.length; i++){
           
        let monthYear: string = '';  
        for(let j=0; j< this.resourcePlanningListExport[i].Projects.length; j++){
          //  console.log("ffffff", this.resourcePlanningListExport[i].Projects[j]);
          monthYear += this.resourcePlanningListExport[i].Projects[j].EffortPlanProjectRole[0].EffortPlanProjectRole + ' | '
          monthYear += this.resourcePlanningListExport[i].Projects[j].ProjectSaleName + ' - '
          this.resourcePlanningListExport[i].Projects[j].ProjectSaleCode + ' '
           for(let k=0; k< this.resourcePlanningListExport[i].Projects[j].ListEffort.length; k++){
            if(k == 0 ) monthYear += '[';
            monthYear += formatDate(this.resourcePlanningListExport[i].Projects[j].ListEffort[k].EffortMonthYear, "MM-yyyy", 'en-US');
            if(k < this.resourcePlanningListExport[i].Projects[j].ListEffort.length - 1){
                monthYear += " | ";
            }
            if(k == this.resourcePlanningListExport[i].Projects[j].ListEffort.length - 1){
               monthYear += '] ';
            }
           }
        }

        let dataPlaning = {
          EffortPlanEmpCode: this.resourcePlanningListExport[i].EffortPlanEmpCode,
          // EffortPlanProjectRole: this.resourcePlanningListExport[i].EffortPlanProjectRole,
          EmployeeName: this.resourcePlanningListExport[i].EmployeeName,
          RoleAndPlanning: monthYear
        }

        dataArr.push(dataPlaning);

      }

      console.log("rowsToExport ===", dataArr)
      this.exportToFile(dataArr)

      }
  }


  exportToFile(data){

      const separator = ',';
      const keys = Object.keys(data[0]);
  
      const csvContent = keys.join(separator) + '\n' +
          data.map(row => keys
                .map(k => {
                  let cell = row[k] === null || row[k] === undefined ? '' : row[k];
                  cell = cell.toString().replace(/"/g, '""');
                  return `"${cell}"`;
                })
              .join(separator)).join('\n');

          const BOM = '\uFEFF';
          const blob = new Blob([BOM + csvContent], {
            type: 'text/csv;charset=utf-8;',
          });
        const url = URL.createObjectURL(blob);
        let fileName =  formatDate(new Date(), "ddMMyyyyHHmm", 'en-US') + '_planning.csv' ;     
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

}



@Component({
  selector: 'resource-planning-report-modal.component',
  templateUrl: 'resource-planning-report-modal.component.html',
})
export class ResourcePlanningReportModal {

  eff: EffortInfo;
  projectNameTh: string | null;
  projectStart: string | null;
  projectEnd: string | null;
  daysInMonth: number;
  timeSheetEmpHours: number;

  mayDay: number;
  actualmanDay: number;
  effMonthYear: string;
  progressEffort = 0;
  progressEffortBar : number = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any){
    this.eff =  this.data.effortInfo ;
    this.projectNameTh = this.data.projectSaleName;
    this.daysInMonth = this.data.daysInMonth;
    this.timeSheetEmpHours = this.data.timeSheetEmpHours;
    
    if(this.data.projectStart) this.projectStart = formatDate(this.data.projectStart, "dd-MM-yyyy", 'en-US');
    
     if(this.data.projectEnd) this.projectEnd = formatDate(this.data.projectEnd, "dd-MM-yyyy", 'en-US');
    this.projectEnd = this.data.projectEnd; 
    console.log("c = ", this.projectStart);
  }

    ngOnInit(): void {
      this.getEffortData();
    }

    getEffortData(){
      console.log("getEffortData == ",this.eff);
      this.mayDay = this.eff.EffortManDay / 8;
      this.actualmanDay = this.timeSheetEmpHours / 8;
      this.effMonthYear = formatDate(this.eff.EffortMonthYear, "yyyy-MM-dd", 'en-US');

      setTimeout(() => {
        this.progressEffort = this.mayDay;
        // this.progressEffortBar = (this.mayDay / this.daysInMonth) * 100;
        if(this.timeSheetEmpHours != 0){
          if(this.actualmanDay == this.eff.EffortManDay){
               this.progressEffortBar = 100;
          }else{
              this.progressEffortBar = (this.timeSheetEmpHours / this.eff.EffortManDay) * 100;
          }
          
        }else{
          this.progressEffortBar =  0;
        }

        this.progressEffortBar = parseFloat(this.progressEffortBar.toFixed(2));

      }, 100);
    }
  
}